import type { TFunction } from "i18next";
import type { DefinitionTooltipInfo } from "src/components/common";

/** Resolve Engagement Overview DefinitionTooltip copy from en.json. */
export const getEngagementTooltipInfo = (
  t: TFunction,
  key: string,
): DefinitionTooltipInfo => {
  const base = `engagementOverview.tooltips.${key}`;
  const formula = t(`${base}.formula`, { defaultValue: "" });
  const bulletsRaw = t(`${base}.bullets`, { returnObjects: true, defaultValue: [] }) as unknown;
  const bullets = Array.isArray(bulletsRaw)
    ? bulletsRaw.filter((item): item is string => typeof item === "string" && Boolean(item.trim()))
    : undefined;

  return {
    description: t(`${base}.description`),
    formula: typeof formula === "string" && formula.trim() ? formula : undefined,
    bullets: bullets?.length ? bullets : undefined,
  };
};
